export default {
    region: process.env.REACT_APP_AWS_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    cookieStorage: {
      domain: process.env.REACT_APP_DOMAIN,
      //expires: 365,
      // OPTIONAL - Cookie secure flag
      // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      secure: true
    },
    oauth: {
      domain: process.env.REACT_APP_AWS_COGNITO_DOMAIN,
      scope: ["aws.cognito.signin.user.admin", "email", "openid", "phone", "profile"],
      redirectSignIn: process.env.REACT_APP_AWS_AD_REDIRECT_IN_URL,
      redirectSignOut: process.env.REACT_APP_AWS_AD_REDIRECT_OUT_URL,
      responseType: "TOKEN"
    }    
  }